export default __webpack_public_path__ + "static/media/sell_stat_illustration.0f4a9f0d.png";